import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { withStyles } from 'material-ui/styles';
import sizeMe from 'react-sizeme';

import StackupEditorComponent from './StackupEditorComponent';
import {
  getStackupLayers,
  getHoveredLayer
} from '../../../../reducers';
import { size as sizePropType } from '../../../../prop-types/sizeMe';
import { stackupLayerPropType } from '../../../../lib/shapes';
import { updateHoveredLayer } from '../../../../actions';
import Material from '../../../../models/Material';

const styles = () =>({
  root: {
    height: '100%',
    minHeight: '100%',
    boxSizing: 'border-box',
  },
});

const paddingTop = 10;
const paddingBottom = 60;

export function StackupEditorContainer(props) {
  const { classes, layers, size, updateHoveredLayer, hoveredLayer } = props;
  const { width, position} = size;
  const  height =   size.height - paddingTop - paddingBottom;

  const unSetHoveredLayer = (layer) => {
    if (hoveredLayer && hoveredLayer.key === layer.key) {
      updateHoveredLayer(null)
    }
  }

  return (
    <StackupEditorComponent
      classes={classes}
      setHoveredLayer={updateHoveredLayer}
      unSetHoveredLayer={unSetHoveredLayer}
      layers={layers}
      width={width}
      height={height}
      position={position}
    />
  );
}

function mapStateToProps(state){
  return {
    layers: getStackupLayers(state),
    hoveredLayer: getHoveredLayer(state),
  }
}

const mapDispatchToProps = {
  updateHoveredLayer
}

StackupEditorContainer.propTypes = {
  classes:        PropTypes.shape({
    root: PropTypes.string
  }).isRequired,
  size: sizePropType.isRequired,
  layers: PropTypes.arrayOf(PropTypes.shape(stackupLayerPropType)).isRequired,
  updateHoveredLayer: PropTypes.func.isRequired,
  hoveredLayer: PropTypes.instanceOf(Material),
};

StackupEditorContainer.defaultProps = {
  hoveredLayer: null,
}

export default compose(
  sizeMe({ monitorHeight: true, monitorPosition: true }),
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(StackupEditorContainer);


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/StackupEditor/StackupEditorContainer.js